'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';
import checkmark from '@/assets/icons/check.svg';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';


export default function ReferralAppBenefits() {
  const { i18n } = useLingui();

  const membershipBenefitList = [{
    title: msg({
      id: 'referral.benefits.high-performance-audio',
      message: `You get a daily high-performance audio from Brendon Burchard and 
        science-backed tools for mindset journaling and habit tracking.`
    }),
    description: msg({
      id: 'referral.benefits.high-performance-audio-value',
      message: `($499 value)`
    })
  }, {
    title: msg({
      id: 'referral.benefits.ai-life-coach',
      message: `The World's #1 AI Life Coach, checking in on you every Friday!`,
    }),
    description: msg({
      id: 'referral.benefits.ai-life-coach-description',
      message: `Our AI Life Coach emails you on Friday and asks you how you felt 
        this week, what obstacles you faced, and what your priorities are for next 
        week. You can call, text or type back! ($999 Value!)`
    })
  }, {
    title: msg({
      id: 'referral.benefits.netflix-of-self-improvement',
      message: `ALL-ACCESS PASS to the "netflix of self-improvement."`,
    }),
    description: msg({
      id: 'referral.benefits.keynotes-and-courses',
      message: `Over 400 keynotes and dozens of in-depth courses from the world's best. 
        Including Mel Robbins, Wayne Dyer, Trent Shelton, Lisa Biyeu, Natalie Ellis, 
        Brendon Burchard and more! (A $5,000+ vault!)`
    })
  }, {
    title: msg({
      id: 'referral.benefits.exclusive-training',
      message: `Exclusive: Advanced Monday Motivation training!`,
    }),
    description: msg({
      id: 'referral.benefits.monday-motivation-with-ed',
      message: `Monday Motivation Sessions with Ed Mylett, the world's #1 mindset coach! (A $2,500 value!)`
    })
  }, {
    title: msg({
      id: 'referral.benefits.free-clarity-call',
      message: `Bonus: Free Clarity Call`,
    }),
    description: msg({
      id: 'referral.benefits.clarity-call-description',
      message: `with a certified high-performance coach to assess your goals, breakthrough 
        mental blocks and fears, and discover your priorities and purpose. This is one-on-one 
        concierge call to help you succeed. (A $600 value)`
    })
  }];

  return (
    <Stack direction="column">
      {membershipBenefitList.map(({ title, description }) => (
        <Stack direction="row" key={title.id}>
          <Image
            src={checkmark.src}
            alt="Checkmark"
            height="24"
            width="16" />
          <div>
            <Typography
              variant="body2"
              display="inline"
              fontWeight={700}
              fontSize="16px"
              lineHeight="24px">
              {i18n.t(title)}
            </Typography>
            {' '}
            <Typography
              variant="body2"
              display="inline"
              fontSize="16px"
              lineHeight="24px">
              {i18n.t(description)}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}